module.exports = __webpack_public_path__ + "img/settingsItem2 (2).11b89595.svg";